import React from 'react';
import config from '../../config';

export default function Footer() {
  return (
    <section id="footer">
      <div className="inner">
        <h2 className="major">GET IN TOUCH</h2>
        <p className="text-center">
        <div>Our products meet the the highest standards in food industry.</div>
        
        <div> NO PRESERVATIVES </div>
        <div>NO FILLERS</div>
        <div>100% GLUTEN FREE</div>
        <div>Always fresh and tasty!</div>
        <div>If you have questions please feel free to call us!</div>
        </p>
        <form method="post" action="https://formspree.io/f/xaylvnpe">
          <div className="fields">
            <div className="field">
              <label htmlFor="name">Name</label>
              <input type="text" name="name" id="name" />
            </div>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input type="email" name="_replyto" id="email" />
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea name="message" id="message" rows="4"></textarea>
            </div>
          </div>
          <ul className="actions">
            <li>
              <input type="submit" value="Send" />
            </li>
          </ul>
        </form>
        <ul className="contact">
          <li className="fa-home">{config.address}</li>

          <li className="fa-phone">{config.phone}</li>

          {config.socialLinks.map(social => {
            const { icon, url, name } = social;
            return (
              
              <a href={url}><li className={`${icon}`} key={url}>
             
                <a href={url}>{name}</a>
              </li>
              </a>
            );
          })}
        </ul>
        <ul className="copyright">
          <li>2021 | All rights reserved</li>
          <li>
            Design: <a href="mailto: adamfugiel@metrikintel.com">Adam Fugiel</a>
          </li>
        </ul>
      </div>
    </section>
  );
}
